import { useCallback, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';

const useUsedCurrencies = () => {
  const [{ companyInfo, fundList }] = useStore() as unknown as UseStoreValues;

  const [usedCurrencies, setUsedCurrencies] = useState<string[]>([]);

  const getCompanyCurrencies = useCallback(() => {
    const currencies: string[] = [];

    // The first 3 currencies should be what we are using in the cap table, financials, and USD
    if (companyInfo?.captable_currency) {
      currencies.push(companyInfo.captable_currency);
    }

    if (companyInfo?.financials_currency) {
      currencies.push(companyInfo.financials_currency);
    }
    return currencies;
  }, [companyInfo]);

  const getFundCurrencies = useCallback(() => {
    const currencies: string[] = [];
    // Next, we add the currencies currently in use by the funds
    if (fundList && !isEmpty(fundList)) {
      fundList.forEach(fund => {
        if (fund.currency) {
          currencies.push(fund.currency);
        }
      });
    }
    return currencies;
  }, [fundList])

  useEffect(() => {
    const USD = 'USD';
    const COMMON_CURRENCIES = ['AUD', 'CAD', 'CNY', 'EUR', 'GBP', 'HKD', 'INR', 'JPY'];

    const currencies: string[] = [];

    // if putFundCurrenciesFirst is false, we add company currencies first
    currencies.push(...getCompanyCurrencies());
    if (!currencies.includes(USD)) {
      currencies.push(USD);
    }
    currencies.push(...getFundCurrencies());
    // Finally, we append the list of common currencies and remove duplicates
    setUsedCurrencies([...new Set(currencies.concat(COMMON_CURRENCIES))]);
  }, [companyInfo, fundList, getCompanyCurrencies, getFundCurrencies]);

  return usedCurrencies;
};

export default useUsedCurrencies;
